import firebase from 'firebase';

export const updateProfileAndAccountInfo = firebase
  .functions()
  .httpsCallable('updateProfileAndAccountInfo-updateProfileAndAccountInfo');

export default 'AccountSettings.api.js';
